<template>
	<div class="success">
		<el-result icon="success" title="支付成功" subTitle="请点击按钮返回拍卖现场">
			<template slot="extra">
				<el-button type="danger" plain size="medium" @click="goConmodity">拍卖现场</el-button>
			</template>
		</el-result>
	</div>
</template>

<script>
	export default {
		name: 'success',
		data() {
			return {
				id:''
			};
		},
		methods: {
			goConmodity(){
				this.$router.push({
					path:'/auction',
					query:{
						id:this.id
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.id = this.$route.query.id
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped"></style>
